function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" {...props}><path fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M9 5.6v4.3" /><circle fill="none" stroke="currentColor" strokeMiterlimit="10" cx="9" cy="12.3" r=".2" /><circle fill="none" stroke="currentColor" strokeMiterlimit="10" cx="9" cy="9" r="6" /></svg>;
});